import React, { PureComponent, ReactNode } from 'react';
import { ErrorBoundary } from '@brighterionai/br-ui';

interface Props {
    children: ReactNode;
    bodyMessage: string;
}

type ErrorType = Error | null | string;

interface State {
    hasError: boolean;
    error: string;
}

class CustomErrorBoundary extends PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            hasError: false,
            error: ''
        };
    }

    static getDerivedStateFromError(error: ErrorType) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true,
            error: error?.toString()
        };
    }

    render() {
        const { error, hasError } = this.state;
        const { bodyMessage, children } = this.props;
        const errorMessage = error || bodyMessage;
        if (hasError) {
            return <ErrorBoundary bodyMessage={errorMessage}>{children}</ErrorBoundary>;
        }
        return children;
    }
}

export default CustomErrorBoundary;
